import {Component,Inject} from 'ng-metadata/core';

import {getAuthenticationMethods} from '../../appConfig/appConfigForward';
import {LoginService} from "./login.service";

@Component({
selector: 'prm-stand-alone-login',
templateUrl: 'components/security/login/stand-alone-login.html'
})



export class PrmStandAloneLogin{
    private authenticationMethods = getAuthenticationMethods();

    constructor(@Inject('loginIcons') public loginIcons,
                @Inject('$state') private $state: ng.ui.IStateService,
                @Inject('$stateParams') private $stateParams,
                private loginService : LoginService) {
        let toState = this.$stateParams.toState;
        if (toState){
            //We want to redirect to this state once login is complete
            this.loginService.toState = toState;
            this.loginService.toParams = JSON.parse(this.$stateParams.toParams);
        }
    }

    public getAuthenticationMethods() {
        return this.authenticationMethods;
    }
    
    public isSingleAuthenticationMethodExternal(){
        return (this.getAuthenticationMethods().length === 1 && this.getAuthenticationMethods()[0].isExternal());
    }
   
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/security/login/standAloneLogin.directive.ts